import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ColorPickerComponent } from 'ngx-color-picker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TranslateModule } from '@ngx-translate/core';

import { RgbaToHexPipe } from './pipes/rgba-to-hex.pipe';

import { SpColorPickerComponent } from './sp-color-picker.component';
import { SpColorPickerDropdownComponent } from './sp-color-picker-dropdown/sp-color-picker-dropdown.component';
import { SpColorPickerPresetsComponent } from './sp-color-picker-presets/sp-color-picker-presets.component';
import { SpColorPickerCustomColorComponent } from './sp-color-picker-custom-color/sp-color-picker-custom-color.component';

import { SpTextGradientComponent } from './sp-text-gradient/sp-text-gradient.component';
import { SpFormControlsModule } from '@components/sp-form-controls';

const MODULES = [
    ColorPickerComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BsDropdownModule,
    TranslateModule,
    SpFormControlsModule,
];

const COMPONENTS = [
    SpColorPickerComponent,
    SpColorPickerDropdownComponent,
    SpColorPickerPresetsComponent,
    SpColorPickerCustomColorComponent,
    SpTextGradientComponent,
];

const PIPES = [RgbaToHexPipe];

@NgModule({
    imports: [...MODULES, ...COMPONENTS, ...PIPES],
    exports: [...COMPONENTS, ...PIPES],
})
export class SpColorPickerModule {}
